import { createActions, createConsts, createReducer } from '../../utils/redux';

export const consts = createConsts('communities', 'currentCommunity', 'SET');
export const actions = createActions(consts);

export default createReducer(null, {
  [consts.SET]: (state, action) => action.payload,
});



// WEBPACK FOOTER //
// ./src/redux/communities/currentCommunity.js